/** `localStorage`, or nothing where merely touching it throws (blocked site data, some private modes). */
export function browserStorage(): Storage | undefined {
  try {
    return typeof window === "undefined" ? undefined : window.localStorage;
  } catch {
    return undefined;
  }
}
